import React from "react";
import { FichasData } from "../../../data/fichas.data";

interface Props {
  car: any;
  setMenu: (value: string) => void;
}

const BottombarOptions: React.FC<Props> = ({ car, setMenu }) => {

  const [ficha, setFicha] = React.useState<any>(null);

  React.useEffect(() => {
    const fichasData: any = FichasData();
    setFicha(fichasData[car.id]);
  }, [car]);

  const openURL = (url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bottombar-menu-options">
      <div className="bottombar-options-content">

        <div className='bottombar-options-button' onClick={() => {setMenu('Gallery')}}>
          <div className='bottombar-options-text'>Galería</div>
        </div>

        {/* setMenu('PDF') */}
        <div className='bottombar-options-button' onClick={() => {openURL(ficha.url_catalog)}}>
          <div className='bottombar-options-text'>Ficha Técnica</div>
        </div>

      </div>
    </div>
  );
};

export default BottombarOptions;